import { Payload } from "vuex";
import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  createBusinessPlan,
  businessPlanList,
  businessPlanListById,
  updateBusinessPlan,
  businessPlanDetails,
  deleteBusinessPlan,
  featureList,
  featureListDetail,
  subscriptionPlan,
} from "@/services/businessPlan";
@Module({
  namespaced: true,
})
export default class Auth extends VuexModule {
  //state
  businessPlanData = [];
  businessPlanDataById = {};
  featureData = [];
  subscriptionListData = [];
  featureDetailData = [];

  //action
  @Action
  public async createBusinessPlan(payload) {
    try {
      const data = await createBusinessPlan(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async businessPlanList() {
    try {
      const data = await businessPlanList();
      this.context.commit("setbusinessPlanList", data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async businessPlanListByIdAction(payload) {
    try {
      const data = await businessPlanListById(payload.id);
      const response = data.data.response;
      this.context.commit(
        "SET_BUSINESS_PLAN_LIST_BY_ID", response
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async updateBusinessPlan(payload) {
    try {
      const data = await updateBusinessPlan(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async businessPlanDetails(payload) {
    try {
      const data = await businessPlanDetails(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteBusinessPlan(payload) {
    try {
      const data = await deleteBusinessPlan(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async featureList() {
    try {
      const data = await featureList();
      this.context.commit("setfeatureList", data.data.response);
      return data.data.response.permissions;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async subscriptionPlan(payload) {
    try {
      const data = await subscriptionPlan(payload);
      this.context.commit("setSubscriptionList", data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async featureListDetail(Payload) {
    try {
      const data = await featureListDetail(Payload);
      this.context.commit("setfeatureListDetail", data.data.response);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  //mutation
  @Mutation
  public setfeatureListDetail(data: any) {
    this.featureDetailData = data;
  }

  @Mutation
  public setSubscriptionList(data: any) {
    this.subscriptionListData = data;
  }
  @Mutation
  public setbusinessPlanList(data: any) {
    this.businessPlanData = data;
  }
  @Mutation
  public SET_BUSINESS_PLAN_LIST_BY_ID(data: any) {
    this.businessPlanDataById = data;
  }
  @Mutation
  public setfeatureList(data: any) {
    this.featureData = data;
  }

  //getters
  get GetBusinessPlanList() {
    return this.businessPlanData;
  }
  get GetBusinessPlanListById() {
    return this.businessPlanDataById;
  }
  get GetfeatureList() {
    return this.featureData;
  }
  get GetsubscriptionList() {
    return this.subscriptionListData;
  }
  get GetfeatureDetails() {
    return this.featureDetailData;
  }
}
